import { createFileRoute, redirect } from "@tanstack/react-router";

// The Paddle refund page (SHO-763). Paddle receipts and past emails still link
// here, so it lands on the money-back policy rather than on a 404.
export const Route = createFileRoute("/_default/refund")({
  beforeLoad: () => {
    throw redirect({ to: "/money-back-policy", replace: true });
  },
});
